<template>
  <v-layout column>
    <v-flex

    ><h2 class="section-title" style="margin-bottom: 0;">{{ title }}</h2></v-flex>
    <v-flex
      v-if="subtitle"
    >
      <h3 class="sub-title">
        <v-icon>mdi-subdirectory-arrow-right</v-icon>
        {{subtitle}}
      </h3>
    </v-flex>
  </v-layout>

</template>
<script>
  export default {
    props: ['title', 'subtitle'],
    data () {
      return {
        time: 0,
        value: 0,
        trace: '',
        color: ''
      }
    },
    computed: {
      size () { }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .section-title {
  border-left: 4px solid #184F9F;
  padding-left: 22px;
  margin-bottom: 10px;
} */
.sub-title {
  border-left: 4px solid #184F9F;
  padding-left: 52px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue